require('./bootstrap');
require('./plugins/imask');
require('./masks');
require('./global');

require('./validate.min.js');
require('./validatePlus.js');